import { DefaultTheme } from 'styled-components'

declare module 'styled-components' {
  export interface DefaultTheme {
    color: {
      primary: string
      secondary: string
      white: string
      black: string
      grey: string
      greyer: string
      lightGrey: string
      darkGrey: string
      background: string
      borderGrey: string
      buttonGrey: string
      buttonGreen: string
      iconGray: string
      error: string
      suggestionPlace: string
      minimapBorder: string
    }
    size: {
      smaller: string
      small: string
      normal: string
      large: string
      big: string
      bigger: string
    }
    font: {
      default: string
      semi: string
    }
    weight: {
      light: number
      normal: number
      semi: number
      bold: number
    }
    padding: {
      pageHorizontalPadding: string
      mobilePageHorizontalPadding: string
    }
  }
}

export const defaultTheme: DefaultTheme = {
  color: {
    primary: '#EDEDED',
    secondary: '#1E1E1E',
    white: '#FFFFFF',
    black: '#1E1E1E',
    lightGrey: '#EDEDED',
    grey: '#b0b0b0',
    darkGrey: '#9F9F9F',
    background: '#FFFFFF',
    borderGrey: '#D0D0D0',
    buttonGrey: '#F2F2F2',
    buttonGreen: '#B6D9B7',
    greyer: '#CFCFCF',
    error: '#FF0734',
    iconGray: '#D0D0D0',
    suggestionPlace: '#6F6F6F',
    minimapBorder: '#3d74e0'
  },
  font: {
    default: 'TheSans Veolia Regular',
    semi: 'TheSans Veolia SemiBold'
  },
  size: {
    smaller: '12px',
    small: '14px',
    normal: '16px',
    large: '18px',
    big: '21px',
    bigger: '24px'
  },
  weight: {
    light: 300,
    normal: 400,
    semi: 500,
    bold: 600
  },
  padding: {
    pageHorizontalPadding: '115px',
    mobilePageHorizontalPadding: '25px'
  }
}
